import api from './axiosInstance';

export const configApi = {
  getAll: () => api.get('/config'),
  getByType: (type, orgUnitId) => {
    const params = orgUnitId ? {orgUnitId} : {};
    return api.get(`/config/${type}`, {params});
  },
  update: (data) => api.put('/config', data),
};
